import { composeIO } from 'react-compose-io'
import { tabelaRegularizacaoEfetivacaoIO } from './TabelaRegularizacaoEfetivacao.IO'
import { TabelaRegularizacaoEfetivacaoView } from './TabelaRegularizacaoEfetivacao.View'

export const TabelaRegularizacaoEfetivacao = composeIO(TabelaRegularizacaoEfetivacaoView, tabelaRegularizacaoEfetivacaoIO)
